import { daysOfTheWeek } from "../elements/Days";
import { monthlyDates } from "../elements/MonthlyDates";
import { offsetDays } from "../elements/OffsetDays";
import { doNavigation } from "../elements/Navigation";
import { renderLegend } from "../helpers/RenderLegend";
import { renderHeader, renderFooter } from "../elements/HeadFoot";
import { cleanup_first_second } from "../elements/Navigation";

let
	screenSizeInit = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
	monthly_view_count,
	viewBreakpoint = 768,
	monthlyHTML = '',
	dd_html = '',
	today = new Date(),
	joinPerformancesByYearMonth = [];

const tapAction = window.ontouchstart === null ? 'touchstart' : 'click';

export const renderTwoMonth = (calendar) => {

	// mobile = 0; desktop = 1;
	window.innerWidth > viewBreakpoint ? monthly_view_count = 1 : monthly_view_count = 0;
	createTwoMonthCalender(calendar);

	// Rerun on resize        
	// window.addEventListener('resize', () => {
	// 	if (!screenSizeInit) {
	// 		window.innerWidth > viewBreakpoint ? monthly_view_count = 1 : monthly_view_count = 0;
	// 	}
	// });

}

const createTwoMonthCalender = (calendar) => {
	let performances = limelight.performances;

	/* ----------------------*/
	/** SET UP PERFORMANCES **/

	// Loop all perforamces
	for (let di = 0; di < performances.length; di++) {
		const todayYear = today.getFullYear();
		const todayMonthRaw = today.getMonth() + 1;
		const todayMonth = todayMonthRaw > 9 ? todayMonthRaw : '0' + todayMonthRaw;
		const todayOperator = todayYear + '-' + todayMonth;

		let performanceYear = performances[di].date.split('-')[0];
		let performanceMonth = performances[di].date.split('-')[1];
		let performanceMonthYear = performanceYear + '-' + performanceMonth;

		// Calculates performances by month
		joinPerformancesByYearMonth.indexOf(performanceMonthYear) === -1 && todayOperator <= performanceMonthYear ? joinPerformancesByYearMonth.push(performanceMonthYear) : null;
	}

	// Reverse order of peformances by month
	joinPerformancesByYearMonth.reverse();

	/* ----------------------------------*/
	/** PREPARE HTML FOR ALL THE MONTHS **/

	daysOfTheWeek('ddd').forEach(d => {
		if (d) {
			dd_html += `<div class="calendar__day">${d}</div>`;
		}
	});

	// Render Month into a string
	for (let index = 0; index < joinPerformancesByYearMonth.length; index++) {

		const month = joinPerformancesByYearMonth[index];
		let isActive;

		// if a starting month has been specified, decide "active" based on that (this month plus next)
		if (calendar.dataset.start_month) {
			let [year, tempmonth] = month.split('-').map(Number);
			if (tempmonth === 1) {
				year -= 1;
				tempmonth = 12;
			} else {
				tempmonth -= 1;
			}
			const prevMonth = year + '-' + (tempmonth.toString().padStart(2, '0'));

			// is this the start month? OR was the previous month the start month (and we're in desktop width)?
			if (calendar.dataset.start_month == month || (window.innerWidth > viewBreakpoint && calendar.dataset.start_month == prevMonth)) {
				isActive = true;
			} else {
				isActive = false;
			}
		} else {
			isActive = index > monthly_view_count ? false : true;
		}

		monthlyHTML += `
            <div class="calendar__month ${isActive ? 'calendar__month--active' : ''}">
                ${renderHeader(month, calendar)}
                <div class="calendar__grid-container">
                    <div class="days">
                      ${dd_html ?? ''}
                    </div>
                    <div class="calendar__grid">
                        ${offsetDays(month, 'before')}
                        ${monthlyDates(month, performances, today)}
                        ${offsetDays(month, 'after')}
                    </div>
                </div>
            </div>`
	}

	/* ----------------------*/
	/** PUT ALL THE HTML TOGETHER **/

	calendar.innerHTML = '';

	// Lengend at the top?
	if (calendar.dataset.layout == 'legend_top') {
		calendar.innerHTML += renderLegend();
	}

	calendar.innerHTML += '<div class="months_container">' + monthlyHTML + '</div>';
	calendar.innerHTML += renderFooter(calendar);

	doNavigation(calendar, viewBreakpoint);
	cleanup_first_second();
}
